// src/routes/Routes.js
import { Routes, Route } from "react-router-dom"
import Page from '../pages/page';
import Login from "../pages/Auth/login";
import Register from "../pages/Auth/register";
import Resetpassword from "../pages/Auth/resetpassword";
import Forgotpassword from "../pages/Auth/forgotpassword";
import NotFound from "../pages/Error/notfound";
import EditProfile from "../pages/Auth/editProfile";
import { AuthProvider } from "../context/AuthContext";
import PrivateRoute from "./privateRoute";
import Beneficiaries from "../pages/beneficiaries";
import Viewcase from "../pages/viewcase";
import Opencases from "../pages/opencases";
import Mycases from "../pages/mycases";
import BeneficiaryCases from "../pages/beneficiarycases";
import Manageusers from "../pages/manageusers";
import ViewBeneficiary from "../pages/viewbeneficiary";
import ApprovedCases from "../pages/approvedcases";

const Index = () => (
    <AuthProvider>

    <div className="App">
        <Routes>
            <Route path="/login" element={ <Login/> } />
            <Route path="/register" element={ <Register/> } />
            <Route path="/forgot-password" element={ <Forgotpassword/> } />
            <Route path="/reset-password" element={ <Resetpassword/> } />
            <Route 
                    path="/edit-profile" 
                    element={<PrivateRoute element={<EditProfile />} />} 
                />
            <Route 
                    path="/beneficiaries"  
                    element={<PrivateRoute element={<Beneficiaries />} />} 
                />
            <Route 
                    path="/open-cases"  
                    element={<PrivateRoute element={<Opencases />} />} 
                />
            <Route 
                    path="/my-cases"  
                    element={<PrivateRoute element={<Mycases />} />} 
                />
            <Route 
                    path="/beneficiary-case/:id"  
                    element={<PrivateRoute element={<BeneficiaryCases />} />} 
                />
            <Route 
                    path="/view-case/:id"  
                    element={<PrivateRoute element={<Viewcase />} />} 
                />
            <Route 
                    path="/"  
                    element={<PrivateRoute element={<Page />} />} 
                />
            
            <Route 
                    path="/manage-users"  
                    element={<PrivateRoute element={<Manageusers />} />} 
                />
            
            <Route 
                    path="/view-beneficiary/:id"  
                    element={<PrivateRoute element={<ViewBeneficiary />} />} 
                />

            <Route 
                path="/approved-cases"  
                element={<PrivateRoute element={<ApprovedCases />} />} 
            />

            <Route path="*" element={<NotFound />} />
        </Routes>
    </div>
    </AuthProvider>
);

export default Index;
